import { memo } from 'react';

import { CustomButton } from 'components/header/style';
import { InfiniteComp } from 'components/infinite-scroll/InfiniteComp';
import { Button, Table, Tooltip } from 'enable-ui';

import { AddItemModal } from 'modules/dashboard/components/AddItemModal';

import { CustomTooltip } from '../styles/lesson';

import { ReactComponent as DropdownIcon } from 'assets/icons/down.svg';

import { useBoolean } from 'hooks';

import { useCommonController } from '../core/controller/common';

const ButtonAddComp = ({
  handleAddLesson,
  lessonColumns,
  handleAddAssessment,
  assessmentColumns,
  institutionId,
  style,
}: {
  handleAddLesson: () => Promise<void>;

  lessonColumns: any;

  handleAddAssessment: () => Promise<void>;

  assessmentColumns: any;
  institutionId: string;
  style?: React.CSSProperties;
}) => {
  const visible = useBoolean(false);

  const {
    lessonData,
    assessmentData,
    hasMoreLesson,
    hasMoreAssessment,
    handleLoadMoreAssessment,
    handleLoadMoreLesson,
    searchAssessment,
    searchLesson,
    onChangeSearchLesson,
    onChangeSearchAssessment,
  } = useCommonController(institutionId);

  return (
    <CustomTooltip style={{ ...style }}>
      <Tooltip
        bg="white"
        trigger="click"
        arrow={false}
        placement="bottom"
        visible={visible.value}
        offset={[0, 10]}
        allowHTML
        interactive
        content={
          <div style={{ padding: '0 8px' }}>
            <AddItemModal
              extraDropdownContentStyle={{ position: 'absolute', left: '-22rem' }}
              title={'Lesson'}
              options={lessonData}
              onAdd={() => {
                handleAddLesson();
                visible.setValue(false);
              }}
              placeholderSearch="Search by lesson"
              searchValue={searchLesson.value}
              onChange={onChangeSearchLesson}
              onClickOutside={() => visible.setValue(false)}
              content={
                <InfiniteComp hasMore={hasMoreLesson.value} handleLoadMore={handleLoadMoreLesson}>
                  <Table
                    columns={lessonColumns}
                    dataSource={lessonData}
                    total={99999}
                    tableKey={''}
                    queryState={{
                      page: 1,
                      limit: 99999,
                    }}
                    paginationConfigs={{
                      show: false,
                    }}
                    headerConfigs={{
                      show: false,
                    }}
                  />
                </InfiniteComp>
              }
              showIcon={false}
            />
            <AddItemModal
              extraDropdownContentStyle={{ position: 'absolute', left: '-22rem' }}
              title={'Assessment'}
              options={assessmentData}
              onAdd={() => {
                handleAddAssessment();
                visible.setValue(false);
              }}
              placeholderSearch="Search by assessment"
              searchValue={searchAssessment.value}
              onChange={onChangeSearchAssessment}
              onClickOutside={() => visible.setValue(false)}
              content={
                <InfiniteComp
                  hasMore={hasMoreAssessment.value}
                  handleLoadMore={handleLoadMoreAssessment}
                >
                  <Table
                    columns={assessmentColumns}
                    dataSource={assessmentData}
                    total={99999}
                    tableKey={''}
                    queryState={{
                      page: 1,
                      limit: 99999,
                    }}
                    paginationConfigs={{
                      show: false,
                    }}
                    headerConfigs={{
                      show: false,
                    }}
                  />
                </InfiniteComp>
              }
              showIcon={false}
            />
          </div>
        }
      >
        <CustomButton>
          <Button onClick={() => visible.setValue((prev) => !prev)}>
            Add <DropdownIcon style={{ marginLeft: 6 }} />
          </Button>
        </CustomButton>
      </Tooltip>
    </CustomTooltip>
  );
};

export default memo(ButtonAddComp);
